import React from 'react';
import { Text } from '@spark';
import EvaluationNormalizationSummary from './EvaluationNormalizationSummary';
import ModelDetailsCodeSection from './ModelDetailsCodeSection';
import ModelDetailsSectionTitle from './ModelDetailsSectionTitle';

const FIELDS = [
  { key: 'systemPrompt', title: 'System Prompt', teacherKey: 'teacher_system_prompt' },
  { key: 'userPrompt', title: 'User Prompt', teacherKey: 'instruction' },
  { key: 'schema', title: 'JSON Schema', teacherKey: 'teacher_schema' },
];

/**
 * Read-only "Teacher Model and Prompt Setup" section for the Model Details
 * summary tab, shown for generative tasks (summarization / content
 * generation) above the student setup. Shows the teacher prompts and schema
 * snapshotted on the distillation event — the values student fields inherit
 * unless overridden.
 */
export default function ModelDetailsTeacherSetupSection({ distillationEvent }) {
  const event = distillationEvent || {};

  return (
    <div>
      <ModelDetailsSectionTitle style={{ marginBottom: 4 }}>
        Teacher Model and Prompt Setup
      </ModelDetailsSectionTitle>
      <Text variant="base-regular" color="secondary" as="div" style={{ marginBottom: 16 }}>
        Prompts and schema used by the teacher model. Student fields inherit these values unless
        overridden.
      </Text>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
        {FIELDS.map((field) => {
          const value = event[field.teacherKey] || '';
          return (
            <ModelDetailsCodeSection
              key={field.key}
              title={field.title}
              titleVariant="base-semibold"
              text={value}
              copyText={value}
              minHeight={80}
            />
          );
        })}
        <EvaluationNormalizationSummary source={event} />
      </div>
    </div>
  );
}
